import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { string, bool } from 'prop-types';

const getStringTitle = (intl, dateTime, options) =>
  `${intl.formatDate(dateTime)} ${intl.formatTime(dateTime, options)}`;

const DateTime = ({ value, seconds, intl }) => {
  const options = seconds ? {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  } : {};
  const title = getStringTitle(intl, value, options);

  return (
    <span className="datetime" title={title}>
      {title}
    </span>
  );
};

DateTime.propTypes = {
  value: string.isRequired,
  intl: intlShape.isRequired,
  seconds: bool,
};

DateTime.defaultProps = {
  seconds: true,
};

export default injectIntl(DateTime);
